import { Component, HostListener, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AssetInScene } from 'src/app/models/AssetInScene';
import { TextAsset } from 'src/app/models/assets/TextAsset';
import { Scene } from 'src/app/models/Scene';
import { AssetTypeService } from 'src/app/services/asset-type.service';
import { ValidationService } from 'src/app/services/validation.service';

@Component({
  selector: 'app-text-asset-wizard',
  templateUrl: './text-asset-wizard.component.html',
  styleUrls: ['./text-asset-wizard.component.scss'],
})
export class TextAssetWizardComponent implements OnInit {

  @Input('assetType') assetType: string;
  @Input('assetInScene') assetInScene: AssetInScene;
  @Input('existingAssetsInScene') existingAssetsInScene: AssetInScene[] = [];
  @Input('existingScenes') existingScenes: Scene[] = [];
  @Input('editing') editing: boolean = false;

  public steps: any = [];

  public currentStepInfo: any = {
    currentStepIndex: 0,
    currentSubStepIndex: 0,
    needHelp: false
  }


  constructor(
    public assetTypeService: AssetTypeService,    
    public modalController: ModalController,
    private alertController: AlertController,
    public validationService: ValidationService,
  ){  
    this.steps = [{
      index: 1,
      description: "Introduction",
      complete: false,
      active: true
    }, {
      index: 2,
      description: "Actions",
      complete: false,
      active: false
    }, {
      index: 3,
      description: "Learning Objectives",
      complete: false,
      active: false
    }];
  }

  ngOnInit() {
    if (!this.editing)
    this.setUpAssetScale(this.assetInScene.sceneAssetRelation, '0.3', '0.3', '0.1');
  }

  async closeModal() {
    const alert = await this.alertController.create({
      header: 'Are you sure?',
      message: 'Are you sure you want to leave? Any changes will not be saved.',
      cssClass: 'leave-alert quizard-alert quizard-leave-alert',
      buttons: [{
        text: 'Yes',
        cssClass: '',
        handler: () => {
          this.modalController.dismiss();
        }
      }, {
        text: 'No',
        cssClass: '',
        handler: () => {
          alert.dismiss();
        }
      }
      ]
    });
    await alert.present();
  }

  validateTextProperties(): boolean{

    let textAsset = this.assetInScene.baseAsset as TextAsset;

    if (!textAsset.name || textAsset.name.trim().length == 0 || !textAsset.text || textAsset.text.trim().length == 0 ) {
      this.goToStep(0);
      return false;
    }
    return true;
  }

  saveText() {

    if (this.validateTextProperties() == false) {
      return;
    }

    let data: any = {
      assetForScene: this.assetInScene,
      assetType: this.assetType,
    }
    this.modalController.dismiss(data);
  }

  setUpAssetScale(sceneAssetRelation, x: string, y: string, z: string) {
    sceneAssetRelation.xScale = x;
    sceneAssetRelation.yScale = y;
    sceneAssetRelation.zScale = z;
    sceneAssetRelation.scale = x + ' ' + y + ' ' + z;
  }

  
  exitHelp() {
    this.currentStepInfo.needHelp = false;
  }

  goToHelp() {
    this.currentStepInfo.needHelp = true;
  }

  goToStep(step: number) {
    if (this.currentStepInfo.currentStepIndex == step){
      this.currentStepInfo.needHelp = false;
      return;
    }
    this.steps[this.currentStepInfo.currentStepIndex].complete = true;
    this.currentStepInfo.currentStepIndex = step;
    this.steps[this.currentStepInfo.currentStepIndex].active = true;
    this.steps[this.currentStepInfo.currentStepIndex].complete = false;
    this.currentStepInfo.needHelp = false;
  }

  previousStep() {
      if (this.currentStepInfo.currentStepIndex > 0)
        this.goToStep(this.currentStepInfo.currentStepIndex - 1);
  }

  nextStep(){
    this.goToStep(this.currentStepInfo.currentStepIndex +1);
  }
}
